import { PlayCircle } from "lucide-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { useStartTour } from "@/hooks/use-start-tour";

/**
 * NOTE: NSAI-5822 — the tour entry point is back in the header, where the
 * redesign puts it, rather than buried in the account menu. It stays a
 * component of its own because `useStartTour` reaches for the sidebar context,
 * which only exists where the sidebar is mounted — the header renders this
 * only when the user has a project, which is also the only case with a sidebar
 * and the only case with anything to tour.
 */
const HeaderTourButtonComponent = (): JSX.Element => {
  const { t } = useTranslation("common");
  const { isOnCallAssistantTerritory, startTour } = useStartTour();

  return (
    <Button
      variant="outline"
      size="sm"
      id="header-take-tour"
      data-testid="header-take-tour"
      onClick={startTour}
      className="h-9 gap-2 rounded-full px-3.5 font-medium transition-[background-color,color,transform] duration-200 ease-out active:scale-[0.97] motion-reduce:transition-none motion-reduce:active:scale-100"
    >
      <PlayCircle className="h-4 w-4" aria-hidden="true" />
      <span className="hidden sm:inline">
        {t(isOnCallAssistantTerritory ? "take_page_tour" : "take_tour")}
      </span>
    </Button>
  );
};

export const HeaderTourButton = memo(HeaderTourButtonComponent);
